import { render } from "./TestimonialsSection.vue?vue&type=template&id=ca6c0b5c&scoped=true"
import script from "./TestimonialsSection.vue?vue&type=script&lang=js"
export * from "./TestimonialsSection.vue?vue&type=script&lang=js"

import "./TestimonialsSection.vue?vue&type=style&index=0&id=ca6c0b5c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca6c0b5c"]])

export default __exports__